import {DTProductSelectionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {productCardSchema} from '../../../../../schemas/productCardSchema';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';

export function convertProductAPICardToAICard(productCard: DTProductSelectionNode) {
  const card: z.input<typeof productCardSchema> = {
    type: NodeType.PRODUCTS,
    cardId: productCard.id,
    name: productCard.name ?? '',
    description: productCard.description ?? '',
    productsSelectionStrategy: productCard.productsSelectionStrategy,
    feedId: productCard.feedId,
    topItemsListId: productCard.topItemLogicId,
    productSetId: productCard.retargetingProductSetId,
    categoryTopItemsListId: productCard.categoryTopItemsLogicId,
    conditions:
      productCard.configuration?.conditions?.map((condition) => ({
        feedColumnSignalKey: condition.feedColumnSignalKey,
        operator: condition.operator,
        signalKey: condition.signalKey,
        feedColumnUIName: condition.feedColumnUIName,
        signalMainCategory: condition.signalMainCategory,
        signalUIName: condition.signalUIName,
      })) ?? [],
    productIds: productCard.productIds ?? [],
  } satisfies z.output<typeof productCardSchema>;

  return card;
}
